import { AnyAction } from 'redux';
import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { DashboardActions } from '../dashboard.actions';

export interface UnfallZaehlstueck {
  isSelected: boolean;
  zaehlstuecke: number;
}

export const unfallZaehlstueckReducer = function (
  sectionState: UnfallZaehlstueck = null,
  action: AnyAction,
): UnfallZaehlstueck {
  switch (action.type) {
    case DashboardActions.UNFALL_SELECTED_CHANGED: {
      const actionPayload: boolean = action.payload;
      return {
        ...sectionState,
        isSelected: actionPayload,
      };
    }
    case GlobalActions.UNFALL_ZAEHLSTUECKE_CHANGED: {
      const actionPayload: number = action.payload;
      return {
        ...sectionState,
        zaehlstuecke: actionPayload,
      };
    }
    default:
      return sectionState;
  }
};
